import { fontSize, fontWeight, unit, themeGet } from '@pocketlaw/tetris';
import { breakpoint } from '@pocketlaw/tetris/deprecated';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
export const Container = styled.div `
  @media ${breakpoint.lapAndUp} {
    max-width: 60vw;
  }
`;
const gridStyles = css `
  display: grid;
  grid-template-columns: 1fr repeat(3, ${unit(20)});
  grid-template-rows: 1fr;
  grid-column-gap: ${unit(4)};
  grid-row-gap: 0;
`;
export const Head = styled.div `
  ${gridStyles};
  margin: ${themeGet('spacing.md')};
`;
export const ColumnHead = styled.div `
  ${fontSize('tiny')};
  ${fontWeight('semibold')};
  color: ${themeGet('colors.gray.700')};
  text-align: left;
  text-transform: uppercase;

  &[data-name] {
    grid-area: 1 / 1 / 2 / 2;
  }

  &[data-type] {
    grid-area: 1 / 2 / 2 / 3;
  }

  &[data-date] {
    grid-area: 1 / 3 / 2 / 4;
  }

  &[data-jurisdiction] {
    grid-area: 1 / 4 / 2 / 5;
  }
`;
export const StyledLink = styled(Link) `
  ${gridStyles};
  padding: ${themeGet('spacing.md')};
  text-decoration: none;

  &:hover {
    background-color: ${themeGet('colors.gray.50')};
  }
`;
export const Highlight = styled.strong `
  ${fontWeight('semibold')};
`;
